export default "__VITE_ASSET__ByRdDpyU__"